import React, {
    createContext, useContext, useEffect, useState,
} from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { clinicsData } from './clinicsData';

export const WidgetPropsContext = createContext();

// eslint-disable-next-line react/prop-types, max-statements
export const WidgetParamsProvider = ({ children }) => {
    const [ clinicData, setClinicData ] = useState();
    const [ doctorId, setDoctorId ] = useState();
    const [ branchId, setBranchId ] = useState();
    const [ clinicId, setClinicId ] = useState('');
    const [ allowDeepLink, setAllowDeepLink ] = useState(false);
    const [ allowLinkToBumba, setAllowLinkToBumba ] = useState(false);
    const [ linkToBumba, setLinkToBumba ] = useState(false);
    const [ allowMmaLink, setAllowMmaLink ] = useState(false);
    const [ allowDoctorBookmark, setAllowDoctorBookmark ] = useState(false);

    const [ currentBranchId, setCurrentBranchId ] = useState();
    const [ isDoctoraOnline, setIsDoctoraOnline ] = useState();
    const [ assignmentIds, setAssignmentIds ] = useState();
    const [ bookingEventName, setBookingEventName ] = useState();
    const [ bookingEventTarget, setBookingEventTarget ] = useState();
    const [ downloadPdf, setDownloadPdf ] = useState(false);
    const [ providerCode, setProviderCode ] = useState('');
    const [ textBeforeBooking, setTextBeforeBooking ] = useState('');
    const [ textBeforeBookingClass, setTextBeforeBookingClass ] = useState('');

    const [ specialtyId, setSpecialtyId ] = useState();
    const [ categoryId, setCategoryId ] = useState();
    const [ serviceId, setServiceId ] = useState();
    const [ serviceBranchId, setServicesBranchId ] = useState();
    const [ serviceDoctorId, setServicesDoctorId ] = useState();
    const [ serviceName, setServiceName ] = useState();
    const [ specialtyName, setSpecialtyName ] = useState();
    const [ doctorName, setDoctorName ] = useState();
    const [ specialityName, setSpecialityName ] = useState();
    const [ targetDoctorId, setTargetDoctorId ] = useState();

    const [ isClosed, setIsClosed ] = useState();
    const history = useHistory();
    const { pathname } = useLocation();

    const widgetCloseHandler = () => {
        setIsClosed(true);
        setTimeout(() => {
            // history.push(pathname, {});
            window.history.pushState({}, document.title, window.location.pathname);
        }, 500);
    };

    // eslint-disable-next-line max-statements, complexity
    const receiveMessage = (event) => {
        const { message } = event.data;

        if (message === 'postWidgetProps') {
            const clinic = clinicsData[event.data.props.CLINIC_ID];
            setClinicId(event.data.props.CLINIC_ID);
            setClinicData(clinic);
            setAllowDeepLink(!!clinic?.allowDeepLink);
            setAllowLinkToBumba(!!clinic?.allowLinkToBumba);
            setAllowMmaLink(!!clinic?.allowMmaLink);
            setLinkToBumba(clinic?.linkToBumba);
            setDownloadPdf(!!clinic?.downloadPdf);
            setAllowDoctorBookmark(!!clinic?.allowDoctorBookmark);
            if (event.data.props.DOCTOR_ID) {
                setDoctorId(event.data.props.DOCTOR_ID);
                setBranchId(event.data.props.BRANCH_ID);
            }
            if (clinic?.providerCode) {
                setProviderCode(clinic.providerCode);
            } else if (clinic?.baseUrl) {
                const urlParts = clinic.baseUrl.split('/');
                setProviderCode(urlParts[urlParts.length - 1]);
            }
            if (event.data.props.CURRENT_BRANCH_ID_FROM_BTN) {
                setCurrentBranchId(event.data.props.CURRENT_BRANCH_ID_FROM_BTN);
            } else if (event.data.props.CURRENT_BRANCH_ID) {
                setCurrentBranchId(event.data.props.CURRENT_BRANCH_ID);
            } else {
                setCurrentBranchId(null);
            }
            if (event.data.props.IS_DOKTORA_ONLINE) {
                setIsDoctoraOnline(event.data.props.IS_DOKTORA_ONLINE);
            }

            if (event.data.props.ASSIGNMENT_IDS) {
                setAssignmentIds(event.data.props.ASSIGNMENT_IDS);
            }
            if (event.data.props.BOOKING_EVENT_NAME) {
                setBookingEventName(event.data.props.BOOKING_EVENT_NAME);
            }
            if (event.data.props.BOOKING_EVENT_TARGET) {
                setBookingEventTarget(event.data.props.BOOKING_EVENT_TARGET);
            }
            if (event.data.props.SPECIALTY_ID) {
                setSpecialtyId(event.data.props.SPECIALTY_ID);
                console.log('event.data.props.SPECIALTY_ID: ', event.data.props.SPECIALTY_ID);
            }
            if (event.data.props.CATEGORY_ID) {
                setCategoryId(event.data.props.CATEGORY_ID);
            }
            if (event.data.props.SERVICE_ID) {
                setServiceId(event.data.props.SERVICE_ID);
            }
            if (event.data.props.SERVICE_BRANCH_ID) {
                setServicesBranchId(event.data.props.SERVICE_BRANCH_ID);
            }
            if (event.data.props.SERVICE_DOCTOR_ID) {
                setServicesDoctorId(event.data.props.SERVICE_DOCTOR_ID);
            }
            if (event.data.props.SERVICE_NAME) {
                setServiceName(event.data.props.SERVICE_NAME);
            }
            if (event.data.props.SPECIALTY_NAME) {
                setSpecialtyName(event.data.props.SPECIALTY_NAME);
            }
            if (event.data.props.DOCTOR_NAME) {
                setDoctorName(event.data.props.DOCTOR_NAME);
            }
            if (event.data.props.SPECIALITY_NAME) {
                setSpecialityName(event.data.props.SPECIALITY_NAME);
            }
            if (event.data.props.BRANCH_ID) {
                setBranchId(event.data.props.BRANCH_ID);
            }
            if (event.data.props.TARGET_DOCTOR_ID) {
                setTargetDoctorId(event.data.props.TARGET_DOCTOR_ID);
            }
            setTextBeforeBooking(event?.data?.props?.TEXT_BEFORE_BOOKING ?? '');
            setTextBeforeBookingClass(event?.data?.props?.TEXT_BEFORE_BOOKING_CLASS ?? '');
        } else {
            // setClinicData(clinicsData.lodem);
            // setDoctorId(344);
            // setBranchId(51);
        }
        if (message === 'closeWidgetAction') {
            widgetCloseHandler();
        }
    };

    useEffect(() => {
        // eslint-disable-next-line no-undef
        window.addEventListener('message', receiveMessage, false);
        return () => {
            // eslint-disable-next-line no-undef
            window.removeEventListener('message', receiveMessage);
        };
    }, []);
    // eslint-disable-next-line max-len
    return (
        <WidgetPropsContext.Provider
            value={{
                ...clinicData,
                doctorId,
                branchId,
                currentBranchId,
                isDoctoraOnline,
                assignmentIds,
                bookingEventName,
                bookingEventTarget,
                isClosed,
                clinicId,
                allowDeepLink,
                allowLinkToBumba,
                linkToBumba,
                downloadPdf,
                providerCode,
                textBeforeBooking,
                textBeforeBookingClass,
                allowDoctorBookmark,
                allowMmaLink,
                specialtyId,
                categoryId,
                serviceId,
                serviceBranchId,
                serviceDoctorId,
                serviceName,
                specialtyName,
                doctorName,
                specialityName,
                targetDoctorId,
            }}>
            {children}
        </WidgetPropsContext.Provider>
    );
};

export const useWidgetProps = () => useContext(WidgetPropsContext);
